import { setInnCode } from "components/app/App.slice";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUserName } from "utils/StoreUtils";
import { setSkipUseEffect } from "../ReleaseHighlight/ReleaseHighlights.slice";
import { reset } from "./HotelUserDashboard.slice";

const InnCodeWrapper = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);

  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const impersonationDetails = useAppSelector((state) => state.app.impersonationDetails);

  const isImpersonated = impersonationDetails?.isImpersonated;
  const onboardingCompletionDatePresent = useAppSelector((state) => state.Onboarding.onboardingCompletionDatePresent);
  const inncodeParam = urlParams.get("inncode");

  const handleOnChange = async (value: string) => {
    const inncodeValue = localStorage.getItem("innCode");
    if (inncodeValue !== value) {
      dispatch(setInnCode(value));
      dispatch(reset());
      localStorage.setItem("innCode", value);
    }
    const payload = {
      filter: {
        innCodes: [value]
      },
      fetchLatest: false
    };
    dispatch(setSkipUseEffect(true));
  };

  useEffect(() => {
    if (inncodeParam) {
      handleOnChange(inncodeParam);
    }
  }, []);

  useEffect(() => {
    if (isImpersonated && !onboardingCompletionDatePresent && location.pathname.split("/")[1] !== "userDashboard") {
      dispatch(
        setFeedbackDetails({
          variant: "warning",
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: `'${getUserName()}' has never logged into BOOST. No data will display. `
        })
      );
    }
  }, [isImpersonated, onboardingCompletionDatePresent, location.pathname]);

  return (
    <div className="page-title-wrapper">
      <div className="home-title">
        <Typography showBold variant="h3" color={tokens.Text.General.Secondary}>
          Home
        </Typography>
      </div>
      {location.pathname.split("/")[1] !== "userDashboard" && (
        <div className="inncode-wrapper">
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Inncode
          </Typography>
          <InncodeDropDown
            className="inn-code-dropdown"
            backgroundColor={"#686B8C"}
            height="24px"
            color={tokens.Text.General.Inverse}
            isCorp={isCorp}
            value={innCode || "undefined"}
            onChange={handleOnChange}
          />
        </div>
      )}
    </div>
  );
};

export default InnCodeWrapper;
